<template>
  <v-app id="blank">
    <v-dialog
      :value="authModalShow"
      content-class="login-modal"
      :overlay-color="'#333'"
      :overlay-opacity="0.8"
      persistent
    >
      <Login
        v-if="authModalShow == 'LOGIN'"
        :dialogView="true"
        @close-modal="authModalShow = null"
        @show-register="(authModalShow = 'REGISTER'), (fromLogin = true)"
        @reset-password="authModalShow = 'RESETPASSWORD'"
      />
      <Register
        v-else-if="authModalShow == 'REGISTER'"
        :dialogView="true"
        :fromLogin="fromLogin"
        @close-modal="(authModalShow = null), (fromLogin = false)"
        @show-login="(authModalShow = 'LOGIN'), (fromLogin = false)"
      />
      <ResetPassword
        v-else-if="authModalShow == 'RESETPASSWORD'"
        :dialogView="true"
        @close-modal="authModalShow = 'LOGIN'"
      />
    </v-dialog>
    <div id="ZN_0VRSjErncaDKLL8"><!--DO NOT REMOVE-CONTENTS PLACED HERE--></div>
    <router-view />
  </v-app>
</template>

<script>
import Login from "@/views/pace-auth/Login";
import Register from "@/views/pace-auth/Register";
import ResetPassword from "@/views/pace-auth/ResetPassword";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Blanklayout",
  components: {
    Login,
    Register,
    ResetPassword,
  },
  data() {
    return {
      fromLogin: false,
    };
  },
  computed: {
    ...mapGetters(["authModal"]),
    authModalShow: {
      get() {
        return this.authModal;
      },
      set(val) {
        this.toggleAuthModal(val);
      },
    },
  },
  methods: {
    ...mapActions(["toggleAuthModal"]),
  },
  mounted() {
    (function () {
      let g = function (e, h, f, g) {
        this.get = function (a) {
          for (
            let a = a + "=",
              c = document.cookie.split(";"),
              b = 0,
              e = c.length;
            b < e;
            b++
          ) {
            let d = c[b]
            for (d ; " " == d.charAt(0); )
              d = d.substring(1, d.length);
            if (0 == d.indexOf(a)) return d.substring(a.length, d.length);
          }
          return null;
        };

        this.set = function (a, c) {
          let b = "";
          b = new Date();
          b.setTime(b.getTime() + 6048e5);
          b = "; expires=" + b.toGMTString();
          document.cookie = a + "=" + c + b + "; path=/; ";
        };

        this.check = function () {
          var a = this.get(f);
          if (a) a = a.split(":");
          else if (100 != e)
            "v" == h && (e = Math.random() >= e / 100 ? 0 : 100),
              (a = [h, e, 0]),
              this.set(f, a.join(":"));
          else return !0;
          var c = a[1];
          if (100 == c) return !0;
          switch (a[0]) {
            case "v":
              return !1;
            case "r":
              return (
                (c = a[2] % Math.floor(100 / c)),
                a[2]++,
                this.set(f, a.join(":")),
                !c
              );
          }
          return !0;
        };

        this.go = function () {
          if (this.check()) {
            var a = document.createElement("script");
            a.type = "text/javascript";
            a.src = g;
            document.body && document.body.appendChild(a);
          }
        };

        this.start = function () {
          console.log('starting ...')
          var t = this;
          "complete" !== document.readyState
            ? window.addEventListener
              ? window.addEventListener(
                  "load",
                  function () {
                    t.go();
                  },
                  !1
                )
              : window.attachEvent &&
                window.attachEvent("onload", function () {
                  t.go();
                })
            : t.go();
        };
      };

      try {
        new g(
          100,
          "r",
          "QSI_S_ZN_0VRSjErncaDKLL8",
          "https://zn0vrsjerncadkll8-qutc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_0VRSjErncaDKLL8"
        ).start();
      } catch (i) {}
    })();
  },
};
</script>

<style lang="scss">
#blank::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: url("../../assets/IPEPA_Artwork_White_RGB.png");
  background-size: 1200px 1200px;
  background-position: -300px -300px;
  background-repeat: no-repeat;
  opacity: 0.6;
}

#blank {
  background: #939597;
  position: relative;

  .v-application--wrap {
    z-index: 1;
  }
}

@media (max-width: 600px) {
  #blank {
    background: #012A4C; // #f15f35;
  }

  #blank::after {
    background-size: 500px 700px;
    background-position: -200px -200px;
  }
}
</style>
